export default class Drag {
  plate = null;
  plateObj = null;
  blockStyle = {}
  maxNum
  blockMap = new Map();
  curBlock = {};
  fn;

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   *    
   */
  constructor({plate, blockStyle, maxNum}) {
    this.plate = document.querySelector(plate) || document.body
    this.plate.style.position = 'relative'

    let offset = this.getNodeOffset(this.plate)
    
    this.plateObj = {
      ...offset,
      width: this.plate.offsetWidth,
      height: this.plate.offsetHeight,
      plateClass: plate
    }
    this.blockStyle = blockStyle
    this.maxNum = maxNum || 10
  }

  /**
   * 创建 方块
   * @param {*} callback 
   *    函數回调
   * @returns 
   */
  createBlock(callback) {
    // 当前 方块 的數量
    let curBlockNumber = document.querySelectorAll(`${this.plateObj.plateClass} .${this.blockStyle.style}`).length,
    uuid = this.getUuid()

    // 最大限制
    if(curBlockNumber >= this.maxNum) return ;

    this.removeSelectBlock()

    // 录入數据
    let blockInfo = JSON.parse(JSON.stringify(this.blockInfo))
    blockInfo.uuid = uuid
    this.blockMap.set(uuid, blockInfo)
    this.curBlock = blockInfo

    // 创建节点
    let block = document.createElement('div')
    block.setAttribute('class', `${this.blockStyle.style} ${this.blockStyle.selectStyle}`)
    block.setAttribute('id', uuid)
    block.style =  `
      zIndex: ${++curBlockNumber};
      width: ${blockInfo.width}px;
      height: ${blockInfo.height}px;
      left: ${blockInfo.x}px;
      top: ${blockInfo.y}px
    `
    this.plate.append(block)

    this.blockCreateEvent(block)
    this.blockAddDrag()

    callback(block)

    this.fn(this.blockMap)
  }

  /**
   * 方块节点添加 事件
   * @param {*} node 
   */
  blockCreateEvent(node) {
    let { plate, blockMap, plateObj } = this
    
    // 点击触发
    node.addEventListener('mousedown', ev => {
      // 阻止事件冒泡
      let event = ev || window.event
      event.stopPropagation()

      let bLayerX = ev.layerX, bLayerY = ev.layerY,
      nodeMap = blockMap.get(node.id)

      this.removeSelectBlock()
      
      // 给当前方块添加 选中样式
      let uuid = node.id
      
      if(!this.curBlock.uuid) {
        this.curBlock = this.blockMap.get(uuid)
        node.classList.add(this.blockStyle.selectStyle)
      }

      plate.onmousemove = e => {
        let {pageX, pageY} = e,
        differX = pageX - bLayerX - plateObj.left, 
        differY = pageY - bLayerY - plateObj.top
        
        nodeMap.x = differX
        nodeMap.y = differY

        // 限制可移动区域 
        if(differX < 0) nodeMap.x = 0
        else if(differX > (plateObj.width - nodeMap.width)) nodeMap.x = plateObj.width - nodeMap.width
        if(differY < 0) nodeMap.y = 0
        else if(differY > (plateObj.height - nodeMap.height)) nodeMap.y = plateObj.height - nodeMap.height

        // 更新左下坐标
        nodeMap.leftBottomCoordinate = {
          x: nodeMap.x + nodeMap.width,
          y: nodeMap.y + nodeMap.height,
        }

        // 更新视图
        node.style.left = nodeMap.x + 'px'
        node.style.top = nodeMap.y + 'px'

        this.fn(this.blockMap)
      }
    })
    
    // 鼠标抬起
    node.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })

    // ---------- 在派生類中定义
    // 右键触发 
    // node.addEventListener('contextmenu', ev => {
    //   ev.preventDefault()

    //   let { rightKeyMenu } = this
    //   rightKeyMenu.style.display = 'block'
    //   rightKeyMenu.style.left = `${ev.pageX}px`
    //   rightKeyMenu.style.top = `${ev.pageY}px`
    //   rightKeyMenu.focus()
      
    //   for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
    //     let item = rightKeyMenu.childNodes[i]

    //     if([...item.classList].indexOf('mislead-choice') > -1) {
    //       item.innerText = this.curBlock.mislead ? '取消误导选项' : '设为误导选项'
    //     }
    //     if([...item.classList].indexOf('opaque-bottom') > -1) {
    //       item.innerText = this.curBlock.opaqueBottom ? '设置为透明底层' : '设置为不透明底层' 
    //       break ;
    //     }
    //   }
    // })
  }

  /**
   * 方块 添加拖拽点
   */
  blockAddDrag() {
    // console.log()
    let dragList = ['leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left'],
    { curBlock } = this, curDom = document.querySelector(`#${curBlock.uuid}`)

    while(curDom.childNodes.length < dragList.length) {
      let nodesLeng = curDom.childNodes.length,
      drag = document.createElement('div')
      drag.setAttribute('class', `drag ${dragList[nodesLeng]}`)
      curDom.append(drag)
      this.dragCreateEvents(drag, dragList[nodesLeng])
    }
  }

  /**
   * 拖拽点创建事件
   * @param {*} dNode 
   * @param {String} dragPosition 'leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left'
   */ 
  dragCreateEvents(dNode, dragPosition) {
    let { plate, blockMap, plateObj } = this,
    parent = dNode.parentNode,
    nodeMap = blockMap.get(parent.id)
    
    dNode.addEventListener('mousedown', ev => {
      // 阻止事件冒泡
      let event = ev || window.event
      event.stopPropagation()
      
      let bLayerX = ev.layerX, bLayerY = ev.layerY
      
      plate.onmousemove = e => {
        let {pageX, pageY} = e,
        differX = pageX - bLayerX - plateObj.left, 
        differY = pageY - bLayerY - plateObj.top

        this.handleDragData(dragPosition, differX, differY, nodeMap)

        // 更新视图
        parent.style.left = nodeMap.x + 'px'
        parent.style.top = nodeMap.y + 'px'
        parent.style.width = nodeMap.width + 'px'
        parent.style.height = nodeMap.height + 'px'

        this.fn(this.blockMap)
      }
    })
    dNode.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })
    document.body.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })
  }

  /**
   * 处理8个方向拖拽數据
   * @param {String} dragPosition 'leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left'
   * @param {*} differX 
   * @param {*} differY 
   * @param {*} nodeMap 
   */
  handleDragData(dragPosition, differX, differY, nodeMap) {
    let { plateObj } = this
    switch(dragPosition) {
      case 'leftTop': 
        if(differX < nodeMap.leftBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }
        if(differY < nodeMap.leftBottomCoordinate.y) {
          nodeMap.y = differY
  
          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        nodeMap.width = nodeMap.leftBottomCoordinate.x - nodeMap.x
        nodeMap.height = nodeMap.leftBottomCoordinate.y - nodeMap.y
      ; break
      case 'top': 
        if(differY < nodeMap.leftBottomCoordinate.y) {
          nodeMap.y = differY

          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        nodeMap.height = nodeMap.leftBottomCoordinate.y - nodeMap.y
      ; break
      case 'rightTop': 
        if(differY < nodeMap.leftBottomCoordinate.y) {
          // 更新方块坐标
          nodeMap.y = differY
          // 限制可移动区域 
          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        nodeMap.width = differX - nodeMap.x
        nodeMap.height = nodeMap.leftBottomCoordinate.y - nodeMap.y
        nodeMap.leftBottomCoordinate.x = nodeMap.x + nodeMap.width
      ; break
      case 'right': 
        // 更新方块大小
        nodeMap.width = differX - nodeMap.x
        nodeMap.leftBottomCoordinate.x = nodeMap.x + nodeMap.width
      ; break
      case 'rightBottom': 
        // 更新方块大小
        nodeMap.width = differX - nodeMap.x
        nodeMap.height = differY - nodeMap.y
        nodeMap.leftBottomCoordinate.x = nodeMap.x + nodeMap.width
        nodeMap.leftBottomCoordinate.y = nodeMap.y + nodeMap.height
      ; break
      case 'bottom': 
        // 更新方块大小
        nodeMap.height = differY - nodeMap.y
        nodeMap.leftBottomCoordinate.y = nodeMap.y + nodeMap.height
      ; break
      case 'leftBottom': 
        if(differX < nodeMap.leftBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }
        if(nodeMap.leftBottomCoordinate.y >= plateObj.height) nodeMap.y = plateObj.height - nodeMap.height

        // 更新方块大小
        nodeMap.width = nodeMap.leftBottomCoordinate.x - nodeMap.x
        nodeMap.height = differY - nodeMap.y
        nodeMap.leftBottomCoordinate.y = nodeMap.y + nodeMap.height
      ; break
      case 'left': 
        if(differX < nodeMap.leftBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }

        // 更新方块大小
        nodeMap.width = nodeMap.leftBottomCoordinate.x - nodeMap.x
      ; break
    }
  }

  /**
   * 去除当前选中方块的样式
   * @returns 
   */
  removeSelectBlock() {
    if(!this.curBlock) return ;
    document.querySelector(`.${this.blockStyle.selectStyle}`) &&
    document.querySelector(`.${this.blockStyle.selectStyle}`).classList.remove(this.blockStyle.selectStyle)
    this.curBlock = {}
  }

  /**
   * 回调方法
   * @param {Function} fn 
   */
  callback(fn) {
    this.fn = fn
  }

  /**
   * 获取dom在文档中的位置坐标
   * @param {node} e 
   * @returns {object<{left: Number, top: Number}>}
   */
  getNodeOffset(e) {
    function getTop(ev){
      let offset = ev.offsetTop;
      if(ev.offsetParent != null){
        offset += getTop(ev.offsetParent);
      }         
      return offset;
    }
  
    function getLeft(ev){
      let offset = ev.offsetLeft;
      if(ev.offsetParent != null){
        offset += getLeft(ev.offsetParent);
      }         
      return offset;
    }
    
    return {left: getLeft(e), top: getTop(e)}
  }

  /**
   * 查询 plate 存在滚动条的所有父节点
   * @param {node} element (default: document.body) 默认以整个文档为范围进行查询
   */
  findscroller(element = document.body) {
    let that = this
    element.onscroll = () => {
      // 过滤
      if(element.contains(that.plate)){
        let {top, left} = that.getNodeOffset(that.plate)
        that.plateObj.top = top - element.scrollTop
        that.plateObj.left = left - element.scrollLeft
      }
    }
    Array.from(element.children).forEach(its => that.findscroller(its))
  }

  /**
   * 随机id 方块唯一识别id
   * @returns 
   */
  getUuid() {
    return 'math-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

}